import { COLOR_VALUE } from './textColors';
import bbcodeMarkdownIt from './bbcodeMarkdownIt';

/**
 * [color=…]…[/color] - flarum/bbcode's COLOR - read by the rich editor's
 * markdown-it as a text_color mark (see addTextColorButton.tsx), so a post
 * written with it (the phpBB ones, the colour button's) shows its colours
 * when edited rather than its tags. A colour inside another (17 phpBB
 * posts) stays raw text - see bbcodeMarkdownIt.
 */
export default bbcodeMarkdownIt({
  name: 'text_color',
  open: /^\[color=([^\]\n]{1,40})\]/i,
  close: '[/color]',
  reopen: '[color=',
  accepts: open => COLOR_VALUE.test(open[1]),
  attrs: open => ({
    color: open[1]
  })
});
flarum.reg.add('champis-forum', 'forum/utils/textColorMarkdownIt', bbcodeMarkdownIt);